import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as auth from '../redux/AuthRedux';
import { getPathWithBasename } from '@/__core/helpers/getBasename';
import { clearUserSession } from '../utils/clearUserSession';

export function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;

    const runLogout = async () => {
      dispatch(auth.actions.logout());
      await clearUserSession();

      if (cancelled) {
        return;
      }

      window.location.replace(getPathWithBasename('/auth/login'));
    };

    void runLogout();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return null;
}
